/**
 * @module dayjs
 * @description This module imports and extends the dayjs library with various plugins.
 * Day.js is a minimalist JavaScript library that parses, validates, manipulates, and displays dates and times for modern browsers with a largely Moment.js-compatible API.
 */

import dayjs from "dayjs"

// Add any plugins you want to use with Day.js
import advancedFormat from "dayjs/plugin/advancedFormat"
import weekday from "dayjs/plugin/weekday"
import weekOfYear from "dayjs/plugin/weekOfYear"
import customParseFormat from "dayjs/plugin/customParseFormat"
import localizedFormat from "dayjs/plugin/localizedFormat"
import isoWeek from "dayjs/plugin/isoWeek"
import relativeTime from "dayjs/plugin/relativeTime"
import utc from "dayjs/plugin/utc"
import "dayjs/locale/en"
import "dayjs/locale/fr"
import isBetween from "dayjs/plugin/isBetween"

/**
 * @function extend
 * @description Extends the dayjs library with the imported plugins.
 * - advancedFormat: Adds more formatting tokens to the format function.
 * - weekday: Gets or sets the day of the week.
 * - weekOfYear: Gets the ISO week of the year.
 * - customParseFormat: Parses custom formatted date strings.
 * - localizedFormat: Adds localized format support for L LL LLL LLLL LT LTS formats.
 * - isoWeek: Gets or sets the ISO week date.
 * - relativeTime: Displays relative time from X (e.g. 3 days ago).
 */
dayjs.extend(advancedFormat)
dayjs.extend(weekday)
dayjs.extend(isBetween)
dayjs.extend(weekOfYear)
dayjs.extend(relativeTime)
dayjs.extend(customParseFormat)
dayjs.extend(localizedFormat)
dayjs.extend(isoWeek)
dayjs.extend(utc)

export default dayjs
